import angular from 'angular';

import component from './experience-details.component';

const ExperienceDetails = angular
    .module('control-room.experience-promoter.components.experience-details', [])
    .component('crExperienceDetails', component);

export default ExperienceDetails;
